export default {
  presenter: 'franc',
  title: 'Vývoj na Linuxu the hard way"',
  subtitle: 'pokročilí/zkušení administrátoři/programátoři',
  text: `
Určeno především pro C/C++ programátory. Jak trasovat, profilovat a ladit na Linuxu. Představení
nejdůležitější nástrojů, které by každý programátor měl znát spolu s typy chyb, které vám umožní
odhalit a obecně problémů, které vám umožní řešit.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/franc-vyvoj.js